import './Template';
import './slider';
import './fancybox';
import './tooltip';

import '../scss/main.scss';
